/* @flow weak */

'use strict';

const React = require('react');
const ReactDOM = require('react-dom');
const _ = require('lodash');

const DialogRenderer = React.createClass({
  propTypes: {
    title: React.PropTypes.string,
    subtitle: React.PropTypes.string,
    buttons: React.PropTypes.array,
    size: React.PropTypes.string,
    class: React.PropTypes.string,
    align: React.PropTypes.string,
    containerStyle: React.PropTypes.object
  },

  getInitialState() {
    return {
      dialogOpen: false,
      visible: false,
      //bodyHeight: 0,
      listItems: [],
      imageUrl: undefined,
      msg: '',
      html: '',
      data: null
    }
  },

  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
  },

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  },

  handleResize() {
    this.setState({ bodyHeight: this.calculateBodyHeight() });
  },

  calculateBodyHeight() {
    let containerHeight = ReactDOM.findDOMNode(this.dialogContainer).offsetHeight;
    let headerHeight = ReactDOM.findDOMNode(this.dialogHeader).offsetHeight;
    let footerHeight = ReactDOM.findDOMNode(this.dialogFooter).offsetHeight;
    let height = containerHeight - headerHeight - footerHeight;

    return height > 0 ? height : 'auto';
  },

  showDialog(imageUrl, listItems, data, msg, html) {
    this.setState({
      dialogOpen: true,
      listItems,
      imageUrl,
      msg,
      html,
      data
    }, () => {
      this.setState({
        visible: true,
        bodyHeight: this.calculateBodyHeight()
      });
    });
  },

  hideDialog() {
    this.setState({
      dialogOpen: false,
      visible: false,
      listItems: [],
      imageUrl: undefined,
      msg: '',
      html: '',
      data: null
    });
  },

  dialogAction(button) {
    let action = button.action;
    let validate = button.validate;
    let validated = true;

    if (validate && typeof validate === 'function') {
      validated = validate();
    }

    if (!validated) { console.log('invalid!'); return; }

    if (action && typeof action === 'function') { action(this.state.data); }
    this.hideDialog();
  },

  render() {
    let containerClass = 'uc-dialog';
    if (this.props.size) { containerClass += ` uc-${this.props.size}-size` }
    if (this.props.align) { containerClass += ` uc-align-${this.props.align}` }
    if (this.state.dialogOpen) { containerClass += ' uc-dialog-open' }
    if (this.props.class) { containerClass += ` ${this.props.class}` }

    let innerContainerClass = this.props.containerClass || 'uc-dialog-container';

    let containerStyle = this.props.containerStyle || {};
    let bodyHeight = this.state.bodyHeight;

    return (
      <div className={containerClass} style={{ visibility: this.state.visible ? 'visible' : 'hidden' }}>
        <div
          ref={(c) => this.dialogContainer = c}
          className={innerContainerClass}
          style={containerStyle}>
          <button title="Close" aria-label="Close" className="uc-dialog-close-btn" onClick={this.hideDialog}>
            <i className='fa fa-close' onClick={this.hideDialog}> </i>
            <span className='uc-new-style-dialog-close-btn' onClick={this.hideDialog}></span>
          </button>
          <div
            ref={(c) => this.dialogHeader = c}
            className="uc-dialog-header"
            style={{ display: this.props.title ? 'block' : 'none' }}>
            <div dangerouslySetInnerHTML={{ __html: this.props.title }}></div>
            {
              this.props.subtitle ?
                <p className="uc-dialog-subtitle">{this.props.subtitle}</p> :
                null
            }
          </div>

          <div
            ref={(c) => this.dialogBody = c}
            className="uc-dialog-body"
            style={{ maxHeight: bodyHeight }}>
            {this.state.msg}
            {this.state.html ? <div dangerouslySetInnerHTML={{ __html: this.state.html }}></div> : null}
            {this.props.children}

            <ul style={{ display: this.state.listItems ? 'block' : 'none' }}>
              {_.map(this.state.listItems, function (listItem, index) {
                return (
                  <li key={index}>{listItem}</li>
                );
              })}
            </ul>

            {this.state.imageUrl ? <img src={this.state.imageUrl} /> : null}
          </div>

          <div
            ref={(c) => this.dialogFooter = c}
            className='uc-dialog-footer'
            style={{ display: this.props.buttons ? 'block' : 'none' }}>
            {_.map(this.props.buttons, (button, i) => {
              return (
                <button
                  key={i}
                  type="button"
                  className={button.btnClass}
                  onClick={this.dialogAction.bind(null, button)}>
                  {button.text}
                </button>
              )
            })}
          </div>
        </div>
      </div>
    );
  }
});

module.exports = DialogRenderer;


// WEBPACK FOOTER //
// ./src/base/scripts/components/renderers/DialogRenderer.jsx